export default __webpack_public_path__ + "static/media/08_DAIF_WHY_DELL_03_loop.9e9ab60c.mp4";